import { DownloadRecentContractsCard } from "./DownloadRecentContractsCard";
import { FeeReportCard } from "./FeeReportCard";
import { InvoiceFeesReportCard } from "./InvoiceFeesReportCard";
import { MarginReportCard } from "./MarginReportCard";
import { OpenContractReportCard } from "./OpenContractReportCard";
import { SummaryReportCard } from "./SummaryReportCard";

/**
 * Reports tab for the OTC dashboard.
 *
 * Each report is a self-contained card with its own filter state and result
 * links; submitting a card clears that card's existing result before issuing
 * the new request.
 *
 * Note: the Position Report intentionally lives on the Open Positions tab,
 * not here.
 */
export function ReportsSection() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <OpenContractReportCard />
      <DownloadRecentContractsCard />
      <SummaryReportCard />
      <MarginReportCard />
      <InvoiceFeesReportCard />
      <FeeReportCard />
    </div>
  );
}
